import type { UserExportSettingsInner } from '@/types/userExportSettingsApiTypes';
import type { FormValues } from '../types';
import { comfortGranularAny } from './granularChecks';

export function savedTravelPrefsCategoryMasterOn(
  nested: UserExportSettingsInner['include_travel_preferences_by_category']
): boolean {
  return nested.toggle || nested.travel || nested.lifestyle || nested.stay || nested.personal;
}

export function effectiveTravelPrefsCategoryToggle(values: FormValues): boolean {
  return (
    values.include_travel_preferences_by_category ||
    values.include_travel_preferences_by_category_travel ||
    values.include_travel_preferences_by_category_lifestyle ||
    values.include_travel_preferences_by_category_stay ||
    values.include_travel_preferences_by_category_personal ||
    comfortGranularAny(values)
  );
}

export function comfortOnlyTravelPrefsCategory(
  values: FormValues
): UserExportSettingsInner['include_travel_preferences_by_category'] {
  const on = comfortGranularAny(values);
  return { toggle: on, travel: false, lifestyle: false, stay: false, personal: on };
}
